// @flow
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { type CatalogRegistration } from '../../types/CatalogRegistration';
import { connect } from 'react-redux';
import { getCatalogRegistration } from '../../redux/modules/catalogRegistration';
import isEqual from 'react-fast-compare';
import { openRegisterForAuctionModal } from '../../redux/modules/modal';
import RegisterLink from './RegisterLink';
import { submitRegisterForCatalog } from '../../redux/modules/registerForCatalog';

const mapStateToProps = (state, { catalogId, itemId }) => {
    const catalogRegistration = getCatalogRegistration(state, catalogId);
    return {
        catalogRegistration,
        itemId,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openRegisterForAuctionModal,
            submitRegisterForCatalog,
        },
        dispatch
    );

type Props = {
    catalogId: number,
    catalogRegistration: CatalogRegistration,
    className: string,
    isCatalogOnly: boolean,
    itemId: ?number,
    openRegisterForAuctionModal: Function,
    registerToBidMessageId: string,
    submitRegisterForCatalog: Function,
};

class RegisterLinkContainer extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { catalogId, catalogRegistration, className, isCatalogOnly, itemId, registerToBidMessageId } = this.props;

        return (
            <RegisterLink
                catalogId={catalogId}
                catalogRegistration={catalogRegistration}
                className={className}
                isCatalogOnly={isCatalogOnly}
                itemId={itemId}
                openRegisterForAuctionModal={this.props.openRegisterForAuctionModal}
                registerToBidMessageId={registerToBidMessageId}
                submitRegisterForCatalog={this.props.submitRegisterForCatalog}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterLinkContainer);
